<template>
    <div class="user-info text-popper" :style="{ width: width, maxWidth: maxWidth }" v-textPopper>
        <span class="small-avatar avatar-border-style-0" :class="'avatar-border-style-' + userInfo.gender">
            <img :src="userInfo.avatar" alt="">
        </span>
        <span class="text-wrapper" :class="{ 'can-click': canClick }" @click="canClick && $router.push(url)">
            {{ userInfo.nickname }}
            <span class="realname" v-if="userInfo.realname">({{ userInfo.realname }})</span>
        </span>
    </div>
</template>

<script lang="ts">
export default {
    props: {
        userInfo: Object,
        canClick: Boolean,
        url: String,
        width: {
            type: String,
            default: 'auto'
        },
        maxWidth: {
            type: String,
            default: '100%'
        }
    }
}
</script>

<style lang="scss" scoped>
.user-info {
    display: inline-block;
    font-size: 14px;
    color: #333;
    vertical-align: middle;

    .small-avatar {
        display: inline-flex;
    }

    &.text-popper {
        width: auto;
    }

    .text-wrapper {
        vertical-align: middle;
    }

    .can-click {
        color: #3C90FF !important;
        font-weight: normal;
        cursor: pointer;

        .realname {
            color: #3C90FF !important;
        }
    }

    .realname {
        color: #999;
    }
}
</style>
